import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StoreEmailTemplateModal from "../modals/emailTemplates/StoreEmailTemplateModal";

const AllEmailTemplatesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
}) => {
  const StoreEmailTemplateModalRef =
    useRef<ElementRef<typeof StoreEmailTemplateModal>>(null);

  const openCreateModal = () =>
    StoreEmailTemplateModalRef.current?.showOrHiddenModal();

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreEmailTemplateModal ref={StoreEmailTemplateModalRef} />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Templates d'emails</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} className="fs--1" />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div id="email-templates-actions">
          <IconButton
            variant="nolina-default"
            size="sm"
            icon={faPlus}
            onClick={openCreateModal}
            transform="shrink-3"
            iconAlign="middle"
          >
            <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
              Nouveau template
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default AllEmailTemplatesHeader;
